<!--
 * @Description: 销售线索
 * @Author: mdb
 * @Date: 2022-07-06 11:24:43
 * @LastEditTime: 2023-04-21 16:12:32
 * @LastEditors: cxh
-->
<template>
  <dc-layout-main :is-breadcrumb="true">
    <dc-layout-content>
      <cos-table
        serial
        rowKey="clueId"
        :row-selection="{ onChange: onSelectRowsChange }"
        :columns="columns"
        v-model:search="queryForm"
        @fetch="getList"
        @mask="showMask"
        ref="tableRef"
        tableId="DcCosFbuSalesClue"
      >
        <template #search>
          <a-form :model="queryForm">
            <dc-form-item label="线索状态">
              <a-radio-group
                v-model:value="queryForm.clueStatus"
                optionType="button"
                :options="clueStatusEnum"
                @change="handleQueryChange('search')"
              />
            </dc-form-item>
            <dc-form-item label="线索类型">
              <a-select
                v-model:value="queryForm.clueTypeList"
                :options="clueTypeEnumComputed"
                placeholder="请选择"
                allowClear
                mode="multiple"
                max-tag-count="responsive"
                show-arrow
              />
            </dc-form-item>
            <dc-form-item label="排序">
              <a-select
                v-model:value="queryForm.sortCollection"
                :options="favoriteStatus"
                placeholder="请选择"
                allowClear
              />
            </dc-form-item>
            <dc-form-item label="未跟进天数">
              <a-select
                v-model:value="queryForm.notFollowDayNumType"
                :options="customerUnfollowDayTypeEnum"
                placeholder="请选择"
                allowClear
              />
            </dc-form-item>
            <dc-form-item label="创建时间">
              <CosRangePicker v-model:startTime="queryForm.startCreateTime" v-model:endTime="queryForm.endCreateTime"/>
            </dc-form-item>
            <dc-form-item label="客户名称">
              <a-input v-model:value="queryForm.customerName" :maxlength="100" allowClear placeholder="请输入"/>
            </dc-form-item>
            <dc-form-item label="联系方式">
              <a-input-group compact>
                <a-select v-model:value="queryForm.contact.type" style="width: 33%" placeholder="请选择">
                  <a-select-option :value="1">手机号</a-select-option>
                  <a-select-option :value="2">固定电话</a-select-option>
                  <a-select-option :value="3">邮箱</a-select-option>
                  <a-select-option :value="4">微信号</a-select-option>
                  <a-select-option :value="5">qq</a-select-option>
                </a-select>
                <a-input
                  v-model:value="queryForm.contact.keyword"
                  :maxlength="100"
                  style="width: 67%"
                  placeholder="请输入"
                  allowClear
                />
              </a-input-group>
            </dc-form-item>
            <dc-form-item label="客户负责人">
              <UserSelect v-model:value="queryForm.follower" placeholder="请选择" allowClear/>
            </dc-form-item>
            <dc-form-item label="线索ID">
              <a-input v-model:value="queryForm.clueId" :maxlength="500" allowClear placeholder="请输入"/>
            </dc-form-item>
            <dc-form-item label="领取时间">
              <CosRangePicker
                v-model:startTime="queryForm.startReceiveTime"
                v-model:endTime="queryForm.endReceiveTime"
              />
            </dc-form-item>
            <dc-form-item label="来源渠道">
              <a-input-group compact>
                <ParamCodeCascader
                  type="search"
                  v-model:ids="queryForm.channelList"
                  appId="cos_fbu"
                  paramCode="fbu_source_channel"
                  style="width: 33%"
                />
                <a-input
                  v-model:value="queryForm.channelExplain"
                  :maxlength="100"
                  style="width: 67%"
                  placeholder="请输入"
                  allowClear
                />
              </a-input-group>
            </dc-form-item>
            <dc-form-item label="客户区域">
              <CustomerAreaCascader type="search" appId="cos_fbu" v-model:ids="queryForm.customerRegionList"/>
            </dc-form-item>
            <dc-form-item label="客户办公地">
              <CosCascader
                v-model:value="queryForm.customerOffice"
                :options="customerAreaEnum"
                :fieldNames="{ label: 'name', value: 'id', children: 'children' }"
                placeholder="请选择"
                change-on-select
                allowClear
              />
            </dc-form-item>
          </a-form>
        </template>

        <template #button>
          <a-button v-permission="'fbu_clue_add_btn'" type="primary" @click="triggerAddOrEdit()">新增</a-button>
          <a-button v-permission="'fbu_clue_person_btn'" @click="handleAssignPerson()">分配负责人</a-button>
          <ImportBtn
            v-permission="'fbu_clue_import_btn'"
            action="/fbu/api/clue/import"
            templateUrl="/fbu/api/clue/template/download"
            @success="handleQueryChange('search')"
          >导入
          </ImportBtn
          >
          <ExportButton v-permission="'fbu_clue_export_btn'" appId="cos_fbu" taskType="201" :search="queryForm"
          >导出
          </ExportButton
          >
          <a-button v-permission="'fbu_clue_merge_btn'" @click="handleClueMarge()">合并</a-button>
          <a-button v-permission="'fbu_clue_back_btn'" @click="handleSendBack()">退回</a-button>
          <a-button v-permission="'fbu_clue_valid_btn'" @click="handleBecomeValid()">申请转有效</a-button>
          <a-button v-permission="'fbu_clue_invalid_btn'" @click="handleBecomeInvalid()">置为无效</a-button>
          <a-button v-permission="'fbu_clue_del_btn'" danger @click="handleDelete()">删除</a-button>
          <a-button v-permission="'fbu_clue_export_details_btn'" @click="handleExportDetails()">导出明细</a-button>
        </template>

        <template #bodyCell="{ column, record, text, index}">
          <template v-if="column.dataIndex === 'customerName'">
            <div class="flex">
              <favorite-icon type="add" v-if="record.collectionId===null"  @click="addFavorite(record,index)"/>
              <favorite-icon type="cancel" v-else  @click="cancelFavorite(record,index)" />
              <p class="new-list-flag" v-if="record.clueStatus !== 8 && record.hasFollow === false">New</p>
              <router-link
                class="ant-table-cell-ellipsis"
                :to="`/fbu/salesClue/view?clueId=${record.clueId}`"
                :title="text"
              >{{ text || '--' }}
              </router-link
              >
            </div>
          </template>
          <template v-if="column.dataIndex === 'channel'">
            <ChannelText appId="cos_fbu" paramCode="fbu_source_channel" :value="text" :desc="record.channelExplain"/>
          </template>
          <template v-if="column.dataIndex === 'customerRegion'">
            <CustomerAreaCascaderText appId="cos_fbu" :value="text"/>
          </template>
          <template v-if="column.dataIndex === 'clueStatus'">
            <dc-status :enums="statusEnum" :value="text"/>
          </template>
          <template v-if="column.dataIndex === 'customerOffice'">
            <CustomerArea type="text" :value="text"/>
          </template>
          <template v-if="column.dataIndex === 'followDesc'">
            <EditorTableText :value="text"/>
          </template>
          <template v-if="column.dataIndex === 'dataIntegrity'">{{ `${text || 0}%` }}</template>
          <template v-if="column.dataIndex === 'action'">
            <MoreButton>
              <SellerButton
                v-permission="'fbu_clue_complete_btn'"
                type="link"
                :workCode="record.follower"
                :disabled="record.clueStatus === 8"
                @click="triggerAddOrEdit(record.clueId, 'required')"
              >完善资料
              </SellerButton
              >
              <a-button
                v-permission="'fbu_clue_write_follow_btn'"
                type="link"
                :disabled="record.clueStatus === 8"
                @click="handleWriteFollowUp(record.clueId)"
              >写跟进
              </a-button
              >
              <SellerButton
                v-permission="'fbu_clue_edit_btn'"
                type="link"
                :disabled="record.clueStatus === 8"
                @click="triggerAddOrEdit(record.clueId)"
              >编辑
              </SellerButton
              >
              <SellerButton
                v-permission="'fbu_clue_potential_btn'"
                type="link"
                :workCode="record.follower"
                :disabled="record.clueStatus === 8"
                @click="handleTurnPotential(record)"
              >转为潜在客户
              </SellerButton
              >
              <SellerButton
                v-permission="'fbu_clue_invalid_btn'"
                type="link"
                :workCode="record.follower"
                :disabled="record.clueStatus === 8"
                @click="handleBecomeInvalid(record)"
              >置为无效
              </SellerButton
              >
              <a-button
                v-permission="'fbu_clue_del_btn'"
                type="link"
                :disabled="record.clueStatus === 8"
                @click="handleDelete(record)"
              >删除
              </a-button
              >
            </MoreButton>
          </template>
        </template>
      </cos-table>
    </dc-layout-content>
  </dc-layout-main>

  <!-- 申请转有效线索弹窗 -->
  <BecomeValid ref="becomeValidRef" @fetch="handleQueryChange('fetch')"/>

  <!-- 分配客户负责人弹窗 -->
  <ClueAssign ref="clueAssignRef" @fetch="handleQueryChange('fetch')"/>

  <!-- 线索合并弹窗 -->
  <ClueMarge ref="clueMargeRef" @fetch="deleteRefresh(1)"/>

  <!-- 置为无效线索弹窗 -->
  <BecomeInvalid ref="becomeInvalidRef" @fetch="handleQueryChange('fetch')"/>

  <!-- 导出明细 -->
  <ExportDetails ref="exportDetailsRef" appId="cos_fbu" :search="queryForm" :taskTypeEnum="[
  { value: 214, label: '签到地址' },
  { value: 218, label: '在售平台' },
  { value: 222, label: '需求海外仓' }
]"/>
</template>

<script setup lang="ts">
import { ref, reactive, computed, onMounted, toRaw } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { Modal as AModal } from 'ant-design-vue'
import { message } from '@dc-platform/dc-components'
import ParamCodeCascader from '@/components/CosCascader/components/ParamCodeCascader.vue'
import ChannelText from '@/components/CosCascaderText/components/channel.vue'
import Modal from '@/hooks/modalType'
import ImportBtn from '@/components/ImportBtn'
import ClueAssign from '../components/ClueAssign.vue'
import BecomeValid from './components/BecomeValid.vue'
import BecomeInvalid from './components/BecomeInvalid.vue'
import ExportDetails from './components/ExportDetails.vue'
import ClueMarge from './components/ClueMarge.vue'
import CustomerArea from '@/components/CustomerArea'
import EditorTableText from '@/components/Editor/src/tableText.vue'
import CustomerAreaCascader from '@/components/CustomerAreaCascader/index.vue'
import CustomerAreaCascaderText from '@/components/CustomerAreaCascader/CustomerAreaCascaderText.vue'
import { listByParamCodes, adminArea, cancelToFav, addToFav } from '@/api/common'
import {
  customerUnfollowDayTypeEnum,
  genderEnum,
  linkRoleTypeEnum,
  flagEnum, favoriteStatus
} from '@/views/gucangSales/commonEnum/dataConfig'
import { clueStatusEnum, clueTypeEnum } from '../dataConfig'
import { salesClueList, salesClueRefund, salesClueDelete, salesClueDetail } from '@/api/gucangSales/clueManage'
import type { ParamCodeItem } from '@/typings/common'
import type { SalesClueParams, SalesClueListItem } from '@/typings/api/clueManage'
import FavoriteIcon from '@/components/FavoriteIcon/index.vue'

const router = useRouter()
const route = useRoute()

// 线索类型枚举列表
const clueTypeEnumComputed = computed(() => clueTypeEnum.filter((item) => item.value !== 0))
const statusEnum = clueStatusEnum.map((item) => ({
  name: item.label,
  value: item.value,
  color: item.color
}))
// 业务参数
const paramCodeData = ref<{
  fbu_source_channel: ParamCodeItem[]
  fbu_industrial_belt: ParamCodeItem[]
  fbu_customer_category: ParamCodeItem[]
}>({
  fbu_source_channel: [], // 客户来源
  fbu_industrial_belt: [], // 产业带
  fbu_customer_category: [] // 客户类别
})
// 获取业务参数
const getByParamCodes = () => {
  listByParamCodes({
    appId: 'cos_fbu',
    paramCodes: ['fbu_source_channel', 'fbu_industrial_belt', 'fbu_customer_category']
  }).then((res) => {
    paramCodeData.value = res.data
  })
}
onMounted(() => getByParamCodes())
// 获取办公地省市区数据
const customerAreaEnum = ref<any[]>([])
const getAdminArea = () => {
  const params = { appId: 'cos_fbu' }
  adminArea(params).then((res) => {
    customerAreaEnum.value = res.data
  })
}
// 获取详情联系人信息
const showMask = (record: SalesClueListItem, callBack: (res: any) => void) => {
  salesClueDetail({ clueId: record.clueId }).then((res) => {
    const { contact } = res.data
    callBack(contact)
  })
}
onMounted(() => {
  getAdminArea()
})

const tableRef = ref()
const queryForm = reactive<SalesClueParams>({
  sortCollection: 1,
  clueStatus: 3,
  contact: { type: 1 }
})
const columns = computed(() => [
  {
    title: '客户名称',
    dataIndex: 'customerName',
    fixed: 'left',
    width: 200
  },
  {
    title: '线索ID',
    dataIndex: 'clueId',
    width: 200
  },
  {
    title: '线索来源',
    dataIndex: 'channel',
    width: 150
  },
  {
    title: '线索类型',
    dataIndex: 'clueType',
    dicData: clueTypeEnum
  },
  {
    title: '线索状态',
    dataIndex: 'clueStatus'
  },
  {
    title: '客户区域',
    dataIndex: 'customerRegion'
  },
  {
    title: '客户负责人',
    dataIndex: 'followerName'
  },
  {
    title: '前负责人',
    dataIndex: 'beforeFollowerName'
  },
  {
    title: '未跟进天数',
    dataIndex: 'notFollowDayNum'
  },
  {
    title: '客户办公地',
    dataIndex: 'customerOffice'
  },
  {
    title: '最新跟进情况',
    dataIndex: 'followDesc'
  },
  {
    title: '是否产业带',
    dataIndex: 'industrialBeltFlag',
    dicData: flagEnum
  },
  {
    title: '产业带',
    dataIndex: 'industrialBelt',
    dicData: paramCodeData.value.fbu_industrial_belt
  },
  {
    title: '产业带名称',
    dataIndex: 'industrialBeltName'
  },
  { title: '客户类别', dataIndex: 'customerCategory', dicData: paramCodeData.value.fbu_customer_category },
  {
    title: '联系人姓名',
    dataIndex: ['contact', 'name'],
    cosType: 'mask'
  },
  {
    title: '手机号',
    dataIndex: ['contact', 'mobile'],
    cosType: 'mask'
  },
  {
    title: '微信号',
    dataIndex: ['contact', 'wechat'],
    cosType: 'mask'
  },
  {
    title: '邮箱',
    dataIndex: ['contact', 'email'],
    cosType: 'mask'
  },
  {
    title: 'QQ号',
    dataIndex: ['contact', 'qq'],
    cosType: 'mask'
  },
  {
    title: '固定电话',
    dataIndex: ['contact', 'tel'],
    cosType: 'mask'
  },
  {
    title: '性别',
    dataIndex: ['contact', 'sex'],
    dicData: genderEnum
  },
  {
    title: '角色',
    dataIndex: ['contact', 'jobRole'],
    dicData: linkRoleTypeEnum
  },
  {
    title: '部门职务',
    dataIndex: ['contact', 'jobDuty']
  },
  {
    title: '资料完善度',
    dataIndex: 'dataIntegrity'
  },
  {
    title: '联系时间',
    dataIndex: ['contactStartTime', 'contactEndTime'],
    cosType: 'timeRange'
  },
  {
    title: '创建时间',
    dataIndex: 'createTime',
    width: 190
  },
  {
    title: '首次领取时间',
    dataIndex: 'firstReceiveTime',
    width: 190
  },
  {
    title: '最后一次领取时间',
    dataIndex: 'lastReceiveTime',
    width: 190
  },
  {
    title: '转潜在客户时间',
    dataIndex: 'stageChangeTime',
    width: 190
  },
  {
    title: '备注',
    dataIndex: 'remark'
  },
  {
    title: '操作',
    dataIndex: 'action',
    width: 220,
    fixed: 'right'
  }
])
const getList = (queryForm: SalesClueParams, callBack: (res: any) => void) => {
  salesClueList(queryForm).then((res) => {
    callBack(res)
  })
}
const handleQueryChange = (type: 'search' | 'fetch') => {
  if (type === 'search') {
    tableRef.value?.search()
  } else {
    tableRef.value?.fetch()
  }
}
const deleteRefresh = (num: number) => {
  const params = toRaw(selectedData.value)
  params.splice(0, num)
  tableRef.value?.delFetch(params, 'clueId')
}

const selectedData = ref<SalesClueListItem[]>([])
const onSelectRowsChange = (selectedRowKeys: string[], selectedRows: SalesClueListItem[]) => {
  selectedData.value = selectedRows
}

// 退回线索
const handleSendBack = () => {
  if (selectedData.value.length === 0) return message.warning('请选择要退回的线索')
  const params = {
    clueIdList: selectedData.value.map((item: SalesClueListItem) => item.clueId)
  }
  salesClueRefund(params).then(() => {
    message.success('退回成功')
    handleQueryChange('fetch')
  })
}

// 申请转有效线索
const becomeValidRef = ref()
const handleBecomeValid = () => {
  if (!selectedData.value.length) return message.warning('请先勾选一条无效线索')
  const hasValid = selectedData.value.some((item: SalesClueListItem) => item.clueType !== 3)
  if (hasValid) return message.warning('仅能勾选无效线索数据提交')
  becomeValidRef.value?.init(toRaw(selectedData.value))
}

// 置为无效线索
const becomeInvalidRef = ref()
const handleBecomeInvalid = (row?: SalesClueListItem) => {
  if (!row && !selectedData.value?.length) return message.warning('请先勾选需要置为无效的线索')
  const paramsRow = row ? [row] : toRaw(selectedData.value)
  becomeInvalidRef.value?.init(paramsRow)
}

// 新增编辑函数
const triggerAddOrEdit = (clueId?: string, isPerfect?: string) => {
  if (clueId) {
    router.push({
      path: '/fbu/salesClue/edit',
      query: {
        clueId,
        isPerfect
      }
    })
  } else {
    router.push('/fbu/salesClue/add')
  }
}
// 跳转写跟进页面
const handleWriteFollowUp = (clueId: string) => {
  router.push({
    path: '/fbu/followUpRecord/add',
    query: {
      followRefId: clueId,
      returnPath: route.fullPath
    }
  })
}
// 分配客户负责人
const clueAssignRef = ref()
const handleAssignPerson = () => {
  if (!selectedData.value.length) return message.warning('请选择需要分配的线索')
  clueAssignRef.value?.init(toRaw(selectedData.value))
}

// 合并线索
const clueMargeRef = ref()
const handleClueMarge = () => {
  if (selectedData.value.length < 2) return message.warning('请选择2个或以上线索合并')
  clueMargeRef.value?.init(toRaw(selectedData.value))
}

const exportDetailsRef = ref()
const handleExportDetails = () => {
  exportDetailsRef.value?.init()
}

// 转潜在客户
const handleTurnPotential = (row?: SalesClueListItem) => {
  if (!row) return
  if (row.clueType === 3) return message.warning('无效线索不能转潜在客户')
  if (row.dataIntegrity !== 100) {
    AModal.confirm({
      title: '请将客户资料补充完整！',
      content: '将客户信息补充完整，才能转潜在！',
      okText: '完善资料',
      onOk() {
        router.push({
          path: '/fbu/salesClue/edit',
          query: {
            clueId: row.clueId,
            isPerfect: 'required'
          }
        })
      },
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      onCancel() {
      }
    })
  } else {
    router.push({
      path: '/fbu/business/add',
      query: {
        saleChanceRefId: row.clueId,
        isFromPotentialCustomer: 1,
        returnPath: route.fullPath
      }
    })
  }
}
const handleDelete = (row?: SalesClueListItem) => {
  if (!row && !selectedData.value?.length) {
    return message.error('请选择要删除的数据')
  }
  const clueIdList: any[] = []
  const customerName = []
  if (row) {
    clueIdList.push(row.clueId)
    customerName.push(row.customerName)
  } else {
    selectedData.value?.forEach((item) => {
      clueIdList.push(item.clueId)
      customerName.push(item.customerName)
    })
  }
  Modal.delete({
    content: `删除【${customerName.join(
      ','
    )}】，会同步删除该线索相关的商机、访客计划、跟进记录，且删除操作无法恢复，请谨慎操作。`,
    onOk() {
      salesClueDelete({ clueIdList }).then(() => {
        message.success('删除线索成功')
        deleteRefresh(0)
      })
    }
  })
}
// 收藏
const addFavorite = (row: SalesClueListItem, index:number) => {
  addToFav({
    appId: 'cos_fbu',
    cosId: row.clueId,
    stage: 1
  }).then((res) => {
    if (res.code === 200) {
      row.collectionId = row.clueId
      tableRef.value?.notifyItem(index, row)
    }
  })
}
// 收藏
const cancelFavorite = (row: SalesClueListItem, index:number) => {
  cancelToFav({
    appId: 'cos_fbu',
    cosId: row.clueId,
    stage: 1
  }).then((res) => {
    if (res.code === 200) {
      row.collectionId = null
      row.collectionTime = null
      tableRef.value?.notifyItem(index, row)
    }
  })
}
</script>
<script lang="ts">
export default { name: 'DcCosFbuSalesClue' }
</script>
<style lang="scss" scoped></style>
